import { createAxiosInstance } from '~/plugins/axios.plugin';

export class PermissionsService {
  static SERVICE_NAME = 'permission';

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.PLATAFORMA_API,
      useAccessToken : true
    });
  }

  getByFunctionId(id) {
    return this.client.get(`academic/function/${id}/permission`);
  }

  link(functionId, permissionId) {
    return this.client.post(`academic/function/${functionId}/permission/${permissionId}`);
  }

  unlink(functionId, permissionId) {
    return this.client.delete(`academic/function/${functionId}/permission/${permissionId}`);
  }

  getPermissionsByRole() {
    return this.client.get(`academic/permission`);
  }
}

export default new PermissionsService();
